var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn && _vm.strongAuthMethod !== undefined
    ? _c(
        "div",
        { staticClass: "reset-password ctsform" },
        [
          !_vm.accountSummaryFlow
            ? _c("h1", [
                _vm._v(_vm._s(_vm.$t("Account.ChangePassword.Heading")))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.brandKey !== "sb"
            ? _c("span", { staticClass: "page-info acc_infomsg_default" }, [
                _vm._v(_vm._s(_vm.$t("Account.ChangePassword.Info.First")))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.strongAuthMethod !== -1
            ? _c("div", { staticClass: "form" }, [
                _c(
                  "div",
                  {
                    staticClass: "control-block",
                    class: { filled: _vm.oldPassword }
                  },
                  [
                    (_vm.showOldPassword ? "text" : "password") === "checkbox"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.oldPassword,
                              expression: "oldPassword"
                            }
                          ],
                          ref: "oldPassword",
                          attrs: {
                            id: "oldPassword",
                            autocomplete: "off",
                            maxlength: _vm.vldPasswordMaxLength,
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.oldPassword)
                              ? _vm._i(_vm.oldPassword, null) > -1
                              : _vm.oldPassword
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.oldPassword,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.oldPassword = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.oldPassword = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.oldPassword = $$c
                              }
                            }
                          }
                        })
                      : (_vm.showOldPassword ? "text" : "password") === "radio"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.oldPassword,
                              expression: "oldPassword"
                            }
                          ],
                          ref: "oldPassword",
                          attrs: {
                            id: "oldPassword",
                            autocomplete: "off",
                            maxlength: _vm.vldPasswordMaxLength,
                            type: "radio"
                          },
                          domProps: { checked: _vm._q(_vm.oldPassword, null) },
                          on: {
                            change: function($event) {
                              _vm.oldPassword = null
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.oldPassword,
                              expression: "oldPassword"
                            }
                          ],
                          ref: "oldPassword",
                          attrs: {
                            id: "oldPassword",
                            autocomplete: "off",
                            maxlength: _vm.vldPasswordMaxLength,
                            type: _vm.showOldPassword ? "text" : "password"
                          },
                          domProps: { value: _vm.oldPassword },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.oldPassword = $event.target.value
                            }
                          }
                        }),
                    _vm._v(" "),
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("Account.ChangePassword.OldPassword"))
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "show_hide",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toggleShowOldPassword()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.showOldPassword
                              ? _vm.$t("MyAccount.HidePassword")
                              : _vm.$t("MyAccount.ShowPassword")
                          )
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm.errorMessages.oldPasswordMissing.val
                    ? _c(
                        "div",
                        {
                          staticClass: "vmsg invalid",
                          attrs: { id: "err_msg_oldPassword_missing" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.ChangePassword.ErrorMessages.OldPassword"
                              )
                            )
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "control-block",
                    class: { filled: _vm.newPassword }
                  },
                  [
                    (_vm.showNewPassword ? "text" : "password") === "checkbox"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newPassword,
                              expression: "newPassword"
                            }
                          ],
                          ref: "newPassword",
                          attrs: {
                            id: "newPassword",
                            autocomplete: "off",
                            maxlength: _vm.vldPasswordMaxLength,
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.newPassword)
                              ? _vm._i(_vm.newPassword, null) > -1
                              : _vm.newPassword
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.newPassword,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.newPassword = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.newPassword = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.newPassword = $$c
                              }
                            }
                          }
                        })
                      : (_vm.showNewPassword ? "text" : "password") === "radio"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newPassword,
                              expression: "newPassword"
                            }
                          ],
                          ref: "newPassword",
                          attrs: {
                            id: "newPassword",
                            autocomplete: "off",
                            maxlength: _vm.vldPasswordMaxLength,
                            type: "radio"
                          },
                          domProps: { checked: _vm._q(_vm.newPassword, null) },
                          on: {
                            change: function($event) {
                              _vm.newPassword = null
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newPassword,
                              expression: "newPassword"
                            }
                          ],
                          ref: "newPassword",
                          attrs: {
                            id: "newPassword",
                            autocomplete: "off",
                            maxlength: _vm.vldPasswordMaxLength,
                            type: _vm.showNewPassword ? "text" : "password"
                          },
                          domProps: { value: _vm.newPassword },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.newPassword = $event.target.value
                            }
                          }
                        }),
                    _vm._v(" "),
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("Account.ChangePassword.NewPassword"))
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "show_hide",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toggleShowNewPassword()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.showNewPassword
                              ? _vm.$t("MyAccount.HidePassword")
                              : _vm.$t("MyAccount.ShowPassword")
                          )
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm.errorMessages.newPasswordMissing.val
                    ? _c(
                        "div",
                        {
                          staticClass: "vmsg invalid",
                          attrs: { id: "err_msg_newPassword_missing" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.ChangePassword.ErrorMessages.NewPasswordMissing"
                              )
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errorMessages.newPasswordSame.val
                    ? _c(
                        "div",
                        {
                          staticClass: "vmsg invalid",
                          attrs: { id: "err_msg_newPassword_same" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.ChangePassword.ErrorMessages.SamePassword"
                              )
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errorMessages.newPasswordStrength.val
                    ? _c("div", {
                        staticClass: "vmsg invalid",
                        attrs: { id: "err_msg_newPassword_strength" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("Account.Join.ErrorMsg.PassStrength", {
                              pwdMinLength: _vm.vldPasswordMinLength
                            })
                          )
                        }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "control-block",
                    class: { filled: _vm.confirmNewPassword }
                  },
                  [
                    (_vm.showConfirmPassword ? "text" : "password") ===
                    "checkbox"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.confirmNewPassword,
                              expression: "confirmNewPassword"
                            }
                          ],
                          ref: "confirmNewPassword",
                          attrs: {
                            id: "confirmNewPassword",
                            autocomplete: "off",
                            maxlength: _vm.vldPasswordMaxLength,
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.confirmNewPassword)
                              ? _vm._i(_vm.confirmNewPassword, null) > -1
                              : _vm.confirmNewPassword
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.confirmNewPassword,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.confirmNewPassword = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.confirmNewPassword = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.confirmNewPassword = $$c
                              }
                            }
                          }
                        })
                      : (_vm.showConfirmPassword ? "text" : "password") ===
                        "radio"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.confirmNewPassword,
                              expression: "confirmNewPassword"
                            }
                          ],
                          ref: "confirmNewPassword",
                          attrs: {
                            id: "confirmNewPassword",
                            autocomplete: "off",
                            maxlength: _vm.vldPasswordMaxLength,
                            type: "radio"
                          },
                          domProps: {
                            checked: _vm._q(_vm.confirmNewPassword, null)
                          },
                          on: {
                            change: function($event) {
                              _vm.confirmNewPassword = null
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.confirmNewPassword,
                              expression: "confirmNewPassword"
                            }
                          ],
                          ref: "confirmNewPassword",
                          attrs: {
                            id: "confirmNewPassword",
                            autocomplete: "off",
                            maxlength: _vm.vldPasswordMaxLength,
                            type: _vm.showConfirmPassword ? "text" : "password"
                          },
                          domProps: { value: _vm.confirmNewPassword },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.confirmNewPassword = $event.target.value
                            }
                          }
                        }),
                    _vm._v(" "),
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Account.ChangePassword.ConfirmNewPassword")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "show_hide",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toggleShowConfirmPassword()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.showConfirmPassword
                              ? _vm.$t("MyAccount.HidePassword")
                              : _vm.$t("MyAccount.ShowPassword")
                          )
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm.errorMessages.confirmNewPasswordMissing.val
                    ? _c(
                        "div",
                        {
                          staticClass: "vmsg invalid",
                          attrs: { id: "err_msg_confirmNewPassword_missing" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.ChangePassword.ErrorMessages.ConfirmNewPassword.Missing"
                              )
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errorMessages.confirmedNewPasswordNotSame.val
                    ? _c(
                        "div",
                        {
                          staticClass: "vmsg invalid",
                          attrs: { id: "err_msg_confirmNewPassword_not_same" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.ChangePassword.ErrorMessages.ConfirmNewPassword.NotSame"
                              )
                            )
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                !_vm.strongAuthMethod
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "control-block",
                          class: { filled: _vm.ssn }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.ssn,
                                expression: "ssn"
                              }
                            ],
                            attrs: {
                              type: "text",
                              inputmode: "numeric",
                              autocomplete: "off",
                              maxlength: 4
                            },
                            domProps: { value: _vm.ssn },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.ssn = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { staticClass: "control-label" }, [
                            _vm._v(_vm._s(_vm.$t("Account.Join.Last4SSN")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _vm.errorMessages.ssnNotDigit.val
                          ? _c(
                              "div",
                              {
                                staticClass: "vmsg invalid",
                                attrs: { id: "err_msg_ssn_not_digit" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Account.Join.ErrorMsg.Last4SSNNonDigit"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errorMessages.ssnMissing.val
                          ? _c(
                              "div",
                              {
                                staticClass: "vmsg invalid",
                                attrs: { id: "err_msg_ssn_miss" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Account.Join.ErrorMsg.Last4SSN")
                                  )
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "control-block",
                          class: { filled: _vm.dateOfBirth },
                          on: { click: _vm.onDateBirth }
                        },
                        [
                          _c(
                            "v-menu",
                            {
                              ref: "datePickerMenu",
                              attrs: {
                                "close-on-click": true,
                                "close-on-content-click": false,
                                "nudge-right": 0,
                                "return-value": _vm.dateOfBirth,
                                lazy: "",
                                transition: "scale-transition",
                                "offset-y": "",
                                "full-width": "",
                                "min-width": "290px"
                              },
                              on: {
                                "update:returnValue": function($event) {
                                  _vm.dateOfBirth = $event
                                },
                                "update:return-value": function($event) {
                                  _vm.dateOfBirth = $event
                                }
                              },
                              model: {
                                value: _vm.datePickerMenu,
                                callback: function($$v) {
                                  _vm.datePickerMenu = $$v
                                },
                                expression: "datePickerMenu"
                              }
                            },
                            [
                              _c("template", { slot: "activator" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: _vm.formattedDate,
                                      expression: "formattedDate",
                                      modifiers: { trim: true }
                                    }
                                  ],
                                  attrs: {
                                    type: "text",
                                    id: "dateOfBirth",
                                    autocomplete: "off",
                                    readonly: "",
                                    name: "reg-dob"
                                  },
                                  domProps: { value: _vm.formattedDate },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.formattedDate = $event.target.value.trim()
                                    },
                                    blur: function($event) {
                                      return _vm.$forceUpdate()
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", { staticClass: "control-label" }, [
                                  _vm._v(_vm._s(_vm.$t("Account.Join.DOB")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("v-date-picker", {
                                ref: "picker",
                                attrs: {
                                  max: _vm.maxDate,
                                  locale: _vm.currentLocale,
                                  "no-title": "",
                                  scrollable: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.checkDateOfBirth()
                                  }
                                },
                                model: {
                                  value: _vm.dateOfBirthProp,
                                  callback: function($$v) {
                                    _vm.dateOfBirthProp = $$v
                                  },
                                  expression: "dateOfBirthProp"
                                }
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.errorMessages.dobMissing.val
                        ? _c(
                            "div",
                            {
                              staticClass: "vmsg invalid",
                              attrs: { id: "err_msg_dateOfBirth_missing" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Account.Join.ErrorMsg.MissingDOB")
                                )
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.strongAuthMethod
                  ? _c("div", { staticClass: "strongauth-data" }, [
                      _vm.strongAuthMethod === 1
                        ? _c(
                            "div",
                            { staticClass: "sqa" },
                            [
                              this.strongAuthSecurityQuestions &&
                              this.strongAuthSecurityQuestions.length > 0
                                ? [
                                    _c("div", { staticClass: "question1" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "control-block question"
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "question-text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.ChangePassword.SecretAnswerTitle"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "question1" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "control-block question"
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "question-text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm
                                                    .strongAuthSecurityQuestions[0]
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "control-block" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "control-block control-block-fullwidth",
                                              class: {
                                                filled: _vm.secretAnswer1
                                              }
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.secretAnswer1,
                                                    expression: "secretAnswer1"
                                                  }
                                                ],
                                                ref: "secretAnswer1",
                                                attrs: {
                                                  type: "text",
                                                  id: "secretAnswer1",
                                                  autocomplete: "off"
                                                },
                                                domProps: {
                                                  value: _vm.secretAnswer1
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.secretAnswer1 =
                                                      $event.target.value
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "control-label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Account.ChangePassword.SecretAnswer"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm.errorMessages
                                              .secretAnswer1Missing.val
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "vmsg invalid",
                                                    attrs: {
                                                      id:
                                                        "err_msg_secretAnswer1_missing"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Account.ChangePassword.ErrorMessages.SecretAnswer"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ])
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "question2" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "control-block question"
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "question-text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm
                                                    .strongAuthSecurityQuestions[1]
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "control-block" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "control-block control-block-fullwidth",
                                              class: {
                                                filled: _vm.secretAnswer2
                                              }
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.secretAnswer2,
                                                    expression: "secretAnswer2"
                                                  }
                                                ],
                                                ref: "secretAnswer2",
                                                attrs: {
                                                  type: "text",
                                                  id: "secretAnswer2",
                                                  autocomplete: "off"
                                                },
                                                domProps: {
                                                  value: _vm.secretAnswer2
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.secretAnswer2 =
                                                      $event.target.value
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "control-label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Account.ChangePassword.SecretAnswer"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm.errorMessages
                                              .secretAnswer2Missing.val
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "vmsg invalid",
                                                    attrs: {
                                                      id:
                                                        "err_msg_secretAnswer2_missing"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Account.ChangePassword.ErrorMessages.SecretAnswer"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ])
                                        ]
                                      )
                                    ])
                                  ]
                                : [
                                    _c("div", { staticClass: "form-error" }, [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "text-error" },
                                          slot: "text-error"
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass: "generic-icon-note"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: { color: "error" }
                                                },
                                                [_vm._v("error")]
                                              ),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Account.ChangePassword.Dialog.Error.SecretQuestionsNotAvailable"
                                                    )
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "Account.ChangePassword.Dialog.Error.Text.ContactSupport"
                                                )
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ])
                                  ]
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "save-container" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.strongAuthMethod === 2
            ? _c("div", { staticClass: "account-page ctsform sa" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Label")))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pin container" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "primary-btn-blue",
                        attrs: {
                          disabled: !_vm.allowAccountUpdate,
                          type: "submit"
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.sendPINBySession()
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Send")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "control-block pin",
                        class: { filled: _vm.pin }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.pin,
                              expression: "pin",
                              modifiers: { trim: true }
                            }
                          ],
                          attrs: {
                            type: "text",
                            id: "pin",
                            autocomplete: "off",
                            maxlength: "50"
                          },
                          domProps: { value: _vm.pin },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.pin = $event.target.value.trim()
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Code")))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.errorMessages.pin
                  ? _c(
                      "div",
                      {
                        staticClass: "vmsg invalid pin",
                        attrs: { id: "err_msg_pin_missing" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.ChangePassword.ErrorMessages.PIN.Missing"
                            )
                          )
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.strongAuthMethod === 3
            ? _c("div", { staticClass: "account-page ctsform sa pin-or-sq" }, [
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("MyAccount.SA.PinOrSA.LineOne")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "securityquestion" }, [
                  _vm._v(_vm._s(_vm.strongAuthSecurityQuestions[0]))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "control-block control-block-fullwidth",
                    class: { filled: _vm.securityAnswer1ModeThree }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.securityAnswer1ModeThree,
                          expression: "securityAnswer1ModeThree",
                          modifiers: { trim: true }
                        }
                      ],
                      attrs: {
                        type: "text",
                        id: "secretAnswer1",
                        autocomplete: "off",
                        maxlength: "50"
                      },
                      domProps: { value: _vm.securityAnswer1ModeThree },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.securityAnswer1ModeThree = $event.target.value.trim()
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.$t("Account.Join.SecurityAnswer1")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "securityquestion" }, [
                  _vm._v(_vm._s(_vm.strongAuthSecurityQuestions[1]))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "control-block control-block-fullwidth",
                    class: { filled: _vm.securityAnswer2ModeThree }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.securityAnswer2ModeThree,
                          expression: "securityAnswer2ModeThree",
                          modifiers: { trim: true }
                        }
                      ],
                      attrs: {
                        type: "text",
                        id: "secretAnswer2",
                        autocomplete: "off",
                        maxlength: "50"
                      },
                      domProps: { value: _vm.securityAnswer2ModeThree },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.securityAnswer2ModeThree = $event.target.value.trim()
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.$t("Account.Join.SecurityAnswer2")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("h1", { staticClass: "or" }, [
                  _vm._v(_vm._s(_vm.$t("MyAccount.SA.PinOrSA.LineTwo")))
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v(_vm._s(_vm.$t("MyAccount.SA.PinOrSA.PIN")))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pin container" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "primary-btn-blue",
                        attrs: {
                          disabled: !_vm.allowAccountUpdate,
                          type: "submit",
                          id: "btn_send_pin"
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.sendPINBySession()
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Send")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "control-block pin",
                        class: { filled: _vm.pin }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.pin,
                              expression: "pin",
                              modifiers: { trim: true }
                            }
                          ],
                          attrs: {
                            type: "text",
                            id: "pin",
                            autocomplete: "off",
                            maxlength: "50"
                          },
                          domProps: { value: _vm.pin },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.pin = $event.target.value.trim()
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Code")))
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.strongAuthMethod === 4
            ? _c("div", { staticClass: "account-page ctsform sa pin-and-sq" }, [
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("MyAccount.SA.PinOrSA.LineOne")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "securityquestion" }, [
                  _vm._v(_vm._s(_vm.strongAuthSecurityQuestions[0]))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "control-block control-block-fullwidth",
                    class: { filled: _vm.securityAnswer1ModeFour }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.securityAnswer1ModeFour,
                          expression: "securityAnswer1ModeFour",
                          modifiers: { trim: true }
                        }
                      ],
                      attrs: {
                        type: "text",
                        id: "secretAnswer1",
                        autocomplete: "off",
                        maxlength: "50"
                      },
                      domProps: { value: _vm.securityAnswer1ModeFour },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.securityAnswer1ModeFour = $event.target.value.trim()
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.$t("Account.Join.SecurityAnswer1")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "securityquestion" }, [
                  _vm._v(_vm._s(_vm.strongAuthSecurityQuestions[1]))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "control-block control-block-fullwidth",
                    class: { filled: _vm.securityAnswer2ModeFour }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.securityAnswer2ModeFour,
                          expression: "securityAnswer2ModeFour",
                          modifiers: { trim: true }
                        }
                      ],
                      attrs: {
                        type: "text",
                        id: "secretAnswer2",
                        autocomplete: "off",
                        maxlength: "50"
                      },
                      domProps: { value: _vm.securityAnswer2ModeFour },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.securityAnswer2ModeFour = $event.target.value.trim()
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.$t("Account.Join.SecurityAnswer2")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("h1", { staticClass: "or" }, [
                  _vm._v(_vm._s(_vm.$t("MyAccount.SA.PinAndSA.LineTwo")))
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v(_vm._s(_vm.$t("MyAccount.SA.PinOrSA.PIN")))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pin container" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "primary-btn-blue",
                        attrs: {
                          disabled: !_vm.allowAccountUpdate,
                          type: "submit",
                          id: "btn_send_pin"
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.sendPINBySession()
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Send")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "control-block pin",
                        class: { filled: _vm.pin }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.pin,
                              expression: "pin",
                              modifiers: { trim: true }
                            }
                          ],
                          attrs: {
                            type: "text",
                            id: "pin",
                            autocomplete: "off",
                            maxlength: "50"
                          },
                          domProps: { value: _vm.pin },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.pin = $event.target.value.trim()
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Code")))
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _vm.errorMessages.securityQuestionsMissing.val
              ? _c(
                  "div",
                  {
                    staticClass: "vmsg invalid",
                    attrs: { id: "err_msg_securityQuestions_missing" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "Account.ChangePassword.ErrorMessages.Questions.Missing"
                        )
                      )
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.strongAuthMethod === 0
            ? _c(
                "div",
                { staticClass: "save-container" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-btn-blue",
                      attrs: {
                        "x-large": "",
                        id: "btn_save",
                        disabled: !_vm.isSADataValid || !_vm.allowAccountUpdate
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.submit()
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("Account.Save")))])]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.strongAuthMethod === 1
            ? _c(
                "div",
                { staticClass: "save-container" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-btn-blue",
                      attrs: {
                        "x-large": "",
                        id: "btn_save",
                        disabled:
                          !(
                            _vm.isSADataValid &&
                            _vm.secretAnswer1 &&
                            _vm.secretAnswer2
                          ) || !_vm.allowAccountUpdate
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.submit()
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("Account.Save")))])]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.strongAuthMethod === 2
            ? _c(
                "div",
                { staticClass: "save-container" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-btn-blue",
                      attrs: {
                        "x-large": "",
                        id: "btn_save",
                        disabled: !_vm.pin || !_vm.allowAccountUpdate
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.submit()
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("Account.Save")))])]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.strongAuthMethod === 3
            ? _c(
                "div",
                { staticClass: "save-container" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-btn-blue",
                      attrs: {
                        "x-large": "",
                        id: "btn_save",
                        disabled:
                          !_vm.modeThreeValidated || !_vm.allowAccountUpdate
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.submit()
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("Account.Save")))])]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.strongAuthMethod === 4
            ? _c(
                "div",
                { staticClass: "save-container" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-btn-blue",
                      attrs: {
                        "x-large": "",
                        id: "btn_save",
                        disabled:
                          !_vm.modeFourValidated || !_vm.allowAccountUpdate
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.submit()
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("Account.Save")))])]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ProcessingDialog",
            {
              attrs: {
                isDialogPersistent: true,
                isProcessing: _vm.isProcessing,
                isSuccess: !_vm.transactionError,
                processingTitle: _vm.$t(
                  "Account.PersonalDetails.Dialog.Processing.Title"
                ),
                processingText: _vm.$t(
                  "Account.PersonalDetails.Dialog.Processing.Text"
                ),
                successTitle: _vm.$t(
                  "Account.ChangePassword.Dialog.Success.Title"
                ),
                successText: _vm.$t(
                  "Account.ChangePassword.Dialog.Success.Text"
                ),
                errorTitle: _vm.$t("Account.ChangePassword.Dialog.Error.Title"),
                closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
              },
              on: { close: _vm.onCloseProcessingDialog },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
                _vm.brandKey !== "sb"
                  ? _c(
                      "p",
                      { staticClass: "generic-icon-note" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "mr-1", attrs: { color: "error" } },
                          [_vm._v("error")]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("Account.Join.Dialog.Error.Text"))
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "response-error" }, [
                  _vm._v(_vm._s(_vm.transactionError))
                ]),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "Account.ChangePassword.Dialog.Error.Text.ContactSupport"
                      )
                    )
                  }
                })
              ])
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ffeef5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ffeef5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/IntegratedWallet/IWChangePassword.vue
// module id = null
// module chunks = 